import { FeatureFlag } from 'adminPanel/types';
import api from 'services/api';

export const getFeatureFlags = (): Promise<FeatureFlag[]> => {
    return api.get('/features/list').then(({ data }) => data);
};
export const getFeatureFlag = (id: number): Promise<FeatureFlag> => {
    return api.get(`/features/${id}`).then(({ data }) => data);
};
export const removeFeatureFlag = (id: number): Promise<void> => {
    return api.delete(`/features/${id}`);
};
export const createFeatureFlag = (featureName: string): Promise<void> => {
    return api
        .post(`/features`, { key: featureName, enabled: true })
        .then(({ data }) => data);
};
